import { Fragment } from 'react'

import { FormattedMessage } from 'react-intl'

import { useMultiframeControls } from '@context/MultiframeControls'
import { SocialSubmissionTypes } from '@enums'

interface IDescriptionPanelProps {
  socialSubmissionType: SocialSubmissionTypes
}

export const MultiframeDescriptionPanel: React.FC<IDescriptionPanelProps> = ({
  socialSubmissionType,
}) => {
  const { frames, activeFrameNumber } = useMultiframeControls()

  return (
    <Fragment>
      <FormattedMessage id={`multiframe.socialSubmissionType.${socialSubmissionType}`} />
      <br />
      <FormattedMessage
        id="multiframe.frame.count"
        values={{ current: activeFrameNumber, total: frames.length }}
      />
    </Fragment>
  )
}

export default MultiframeDescriptionPanel
